import React from 'react';

import ThreadsBar from '../../../ThreadsBar';
import NewThreadIcon from '@/assets/icons/new-thread.svg?react';
import { BackButton } from '@/components/atoms/BackButton';
import { ThreadMessage } from '@/types';

interface AnswerSidebarProps {
  userMessage: ThreadMessage | undefined;
  createNewThread: () => void;
  goToThread: (threadId: string) => void;
  handleBack: () => void;
}

const ChatBubble = ({ text }: { text: string }) => {
  return (
    <div className="max-h-52 w-fit max-w-[90%] overflow-y-auto rounded-xl border bg-gray-50 px-3 py-1 text-xs whitespace-pre-wrap">
      {text}
    </div>
  );
};

const AnswerSidebar: React.FC<AnswerSidebarProps> = ({ userMessage, createNewThread, goToThread, handleBack }) => {
  return (
    <div className="flex w-56 min-w-[14rem] flex-col rounded-tl-lg border-r bg-white">
      <div className="flex h-1/2 flex-col justify-between border-b border-dashed pt-2 pb-2">
        <div className="flex items-center gap-4 border-b pb-1 text-sm font-semibold text-gray-800">
          <BackButton onClick={handleBack} />
          <p>Question</p>
          <div className="flex items-center gap-2">
            <NewThreadIcon
              onClick={createNewThread}
              className="h-6 w-6 rounded-full p-1 hover:cursor-pointer hover:bg-gray-200"
            />
          </div>
        </div>

        <div className="flex h-full flex-col justify-between overflow-y-auto px-2 pt-4">
          <div className="flex flex-col items-start gap-2">
            <ChatBubble text={userMessage ? userMessage.content : '...'} />
          </div>
        </div>
      </div>

      <div className="h-1/2 bg-gray-50/50">
        <ThreadsBar goToThread={goToThread} />
      </div>
    </div>
  );
};

export default AnswerSidebar;
